export const CANDIDATE_COUNT = "candidate_count"
export const CANDIDATE_COUNT_SUCCESSFUL = "candidate_count_successfull"
export const CANDIDATE_COUNT_FAILED = "candidate_count_failed"
export const CANDIDATE_SEARCH_COUNT = "candidate_search_count"
export const CANDIDATE_SEARCH_COUNT_SUCCESSFUL = "candidate_search_count_successfull"
export const CANDIDATE_SEARCH_COUNT_FAILED = "candidate_search_count_failed"